import React, { useState, useEffect } from "react";
import { isAuthenticated } from "../../../auth";
import moment from "moment";
moment().format();

const Order = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/roombook`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setData(data), setLoading(false);
      });
  }, [props]);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  return (
    <div className="container mt-5">
      <div className="card-header">
        <h2> List of Booked Room</h2>
        {showloading()}
        <ol className="list-group list-group-flush ">
          {data
            .map((booked) => {
              return (
                <li
                  key={booked._id}
                  className="list-group-item mb-3 "
                  style={{ backgroundColor: "#FCCE01" }}
                >
                  {"  "}

                  <p>
                    <b>Booked customer name: </b>
                    {booked.name}
                  </p>
                  <p>
                    <b>Booked customer Email:</b> {booked.email}
                  </p>
                  <p>
                    {" "}
                    <b>Booked customer Ph. no: </b> {booked.phone}
                  </p>
                  <p>
                    {" "}
                    <b>Booked customer college name:</b> {booked.college}
                  </p>
                  <p>
                    <b>Booked customer paymentId:</b> {booked.paymentId}
                  </p>
                  <p>
                    <b>Booked customer orderId:</b> {booked.orderId}
                  </p>
                  <p>
                    <b>Booked Room name:</b> {booked.roomname}
                  </p>
                  <img
                    width="120px"
                    src={`${process.env.REACT_APP_API_URL}/home/photo/${booked.roomimgid}`}
                    style={{ maxHeight: "100%", maxWidth: "100%" }}
                    className="mb-3"
                  />
                  <p>
                    <b>Booked Room Desc.:</b> {booked.roomdesc}
                  </p>
                  <p>
                    <b>Booked Room Date.:</b>{" "}
                    {moment(booked.createdAt).format(
                      "dddd, MMMM Do YYYY, h:mm:ss a"
                    )}
                  </p>
                </li>
              );
            })

            .reverse()}
        </ol>
      </div>
    </div>
  );
};

export default Order;
